<header>
	<dx-toolbar class="header-toolbar">
		<dxi-item
			*ngIf="menuToggleEnabled"
			location="before"
			widget="dxButton"
			cssClass="menu-button"
			[options]="{
				icon: 'menu',
				stylingMode: 'text',
				onClick: toggleMenu
			}"
		>
		</dxi-item>
		<dxi-item
			*ngIf="title"
			location="before"
			cssClass="header-title"
			[text]="title"
		>
		</dxi-item>
		<dxi-item
			*ngIf="tenants.length === 1"
			location="center"
			cssClass="header-title"
			[text]="tenantName"
		>
		</dxi-item>		
		<dxi-item 
			*ngIf="tenants.length > 1"
			location="center"
			cssClass="header-title"
			locateInMenu="auto"
		>
			<dx-select-box
				#tenantSelectBox
				stylingMode="filled"
				displayExpr="name"
				valueExpr="id"
				width="400px"
				[value]="tenantId"
				[dataSource]="tenants"
				(onValueChanged)="handleTenantSelect($event)"
			>
			</dx-select-box>
		</dxi-item>

		<!-- <dxi-item
			location="after"
			widget="dxTextBox"
			locateInMenu="auto"
			cssClass="global-search-box"
			[options]="{
				stylingMode: 'filled',
				mode: 'search',
				placeholder: 'Search',
				width: 180
			}"
		>
		</dxi-item> -->
		
		<dxi-item location="after" locateInMenu="never">
			<ng-container *dxTemplate>
				<theme-switcher></theme-switcher>
			</ng-container>
		</dxi-item>

		<!-- <dxi-item location="after">
			<div *dxTemplate>
				<div class="messages">
					<dx-button
						icon="belloutline"
						stylingMode="text"
					>
					</dx-button>
					<div class="dx-badge"> 4 </div>
				</div>
			</div>
		</dxi-item> -->

		<dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
			<div *dxTemplate="let data of 'item'">
				<user-panel
					[user]="user"
					[menuItems]="userMenuItems"
					menuMode="context"
				></user-panel>
			</div>
		</dxi-item>
		<div *dxTemplate="let data of 'menuItem'">
			<user-panel
				[user]="user"
				[menuItems]="userMenuItems"
				menuMode="list"
			></user-panel>
		</div>
	</dx-toolbar>
</header>
